module.exports = __webpack_public_path__ + "static/media/template-users.86641b60.xlsx";